var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-radio-group',{staticClass:"demo-inline-spacing",attrs:{"options":_vm.ratingOptions,"name":"radio-inline"},model:{value:(_vm.selectedRating),callback:function ($$v) {_vm.selectedRating=$$v},expression:"selectedRating"}})}
var staticRenderFns = []

export { render, staticRenderFns }